import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noticeFilter'
})
export class NoticeFilterPipe implements PipeTransform {
 
  transform(notices: any[], searchNotice: any): unknown {
    if (!searchNotice) return notices
    searchNotice = searchNotice.toLowerCase();
    let filteredNotice = notices.filter(notice => notice.notice_title.toLowerCase().includes(searchNotice))
    return filteredNotice;
  }

}
